export var isLastChip = (index, numOfColumns) => {
  return (index + 1) % numOfColumns === 0;
};
export var isLastRow = (index, numOfColumns, length) => {
  return Math.floor(index / numOfColumns) === Math.floor((length - 1) / numOfColumns);
};